<template>
  <div v-if="selectedMenu == 1" class="uv-card">
    <div class="uv-card-body">
      <ModuleHeader>Miembros</ModuleHeader>
      <uv-data-table
        :config="config"
        :data="comp_clients"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>
  </div>
</template>

<script>
import uvDataTable from "../MainComponents/DataTable.vue";
import Membresia from "../../clases/Membresias/Membresia.js";
import MembresiaPlan from "../../clases/Membresias/MembresiaPlan.js";
import Cliente from "../../clases/Cliente.js";
export default {
  name: "Miembros",
  components: {
    uvDataTable,
  },
  data() {
    return {
      indexComponent: 1,
      access: [],
      gruposCliente: [],
      showModal: false,
      clientAdd: {
        nombre: "",
        apellidos: "",
        correo: "",
        telefono: "",
        grupo: "",
        tipoMembresia: "",
        CuentaMembresia: "",
        TitularMembresia: "",
      },
      config: {
        selectableRow: true,
        allowExport: true,
        rawText: "Miembros",
        orderByCol: { Field: "NumeroMembresia", Type: "Asc" },
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Detalle Membresia",
            icon: "lni lni-list",
            buttonId: "detalleMembresias",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "NCompleto",
          },

          {
            title: "Plan de Membresia",
            text: "Plan de Membresia",
            value: "PlanName",
            dataName: "PlanName",
            canBeFiltered: true,
          },
          {
            title: "Numero de Membresia",
            text: "Numero de Membresia",
            value: "Code",
            dataName: "Code",
            canBeFiltered: true,
          },
          /*{
            title: "Num. Membresia",
            dataName: "ExtraData",
            format: (row) => {
              return row;
            },
          },*/
          {
            text: "Email",
            value: "Correo",
            title: "Email",
            dataName: "Correo",
            format: (row) => {
              return row.Correo != "" ? row.Correo : "Sin Correo";
            },
          },
        ],
      },
      fullAccess: false,
      idSelected: "",
      claims: {},
      data_clientes: [],
      data_membresias: [],
      selectedMenu: 1,
      Catalogos: {
        PlanesMembresias: [],
        Membresias: [],
      },
    };
  },
  computed: {
    comp_clients() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((element) => {
        element.Code = "";
        if (element.id != "PUBLICOGENERAL") {
          if (element.ExtraData?.Membresia?.Membresia) {
            let dataMembresia = this.$pgsHelper.getById(
              this.Membresias,
              "Id",
              element.ExtraData?.Membresia?.Membresia
            );
            if (dataMembresia) {
              element.NumeroMembresia = dataMembresia?.Code?.Pos;
              element.NombreAlias =
                element.Nombres +
                (element.Apodo ? " (" + element.Apodo + ")" : "");
              let dataPlan = this.$pgsHelper.getById(
                this.PlanesMembresias,
                "Id",
                element.ExtraData?.Membresia?.Plan
              );
              element.PlanName = dataPlan.Nomb;
              element.Code =
                dataMembresia?.Code?.Pre + "" + dataMembresia?.Code?.Pos;
              element.NCompleto =
                element.Nombres +
                " " +
                element.Apellidos +
                (element.Apodo ? " (" + element.Apodo + ")" : "");
              clientes.push(element);
            }
          }
        }
      });
      clientes.forEach((cli) => {
        cli.value = cli.id;
        cli.text = cli.getNombreCompleto();
      });
      return clientes;
    },
    PlanesMembresias() {
      return MembresiaPlan.getMembresiasPlanList();
    },
    Membresias() {
      return Membresia.getMembresiasList();
    },
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "detalleMembresias") {
        let dataCliente = this.$pgsHelper.getById(
          this.comp_clients,
          "Id",
          idSelected[0]
        );
        this.$router.push({
          path:
            "detalleMembresias/" + dataCliente.ExtraData.Membresia.Membresia,
        });
      }
    },
    toggleModal(open) {
      this.showModal = open;
    },
  },
  beforeMount: function() {
    this.$emit("startLoading");
  },
  mounted: async function() {
    //this.Catalogos.PlanesMembresias  = await MembresiaPlan.getMembresiasPlanList();
    //this.Catalogos.Membresias        = await Membresia.getMembresiasList();
    this.$emit("endLoading");
  },
};
</script>
